import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledGamificationScoreBoard = styled.div`
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 0px 10px;

  &:not(.score-loading) {
    background: white;
    border-radius: 10px;
    color: black;
    border: 2px solid black;
  }

  .spin {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 30px;
    color: ${Colors.primary};
    font-size: 18px;
  }

  .xp {
    display: flex;
    align-items: center;
    gap: 3px;
  }

  .stars {
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 3px;
  }

  @media (orientation: landscape) {
    &.vertical {
      flex-direction: column;
      padding: 10px 4px;
      text-align: center;

      .xp {
        flex-direction: column;
        gap: 0px;
      }

      .stars {
        flex-direction: column;
        gap: 0px;
      }
    }
  }
`;
